import * as types from "../types";

const initialState = {
  transcriptsData: [],
  isDataUpdated: false,
  isError: false,

};

export default function transcripts(
  state = initialState,
  { type, payload } = {}
) {
  switch (type) {
    case types.GET_TRANSCRIPTS_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        transcriptsData: payload,
      };

    case types.GET_TRANSCRIPTS_DATA_FAILED:
      return {
        ...state,
        isError: true,
        transcriptsData: [],
      };
    case types.PUT_EDIT_TRANSCRIPTS_DATA_SUCCESS:
      return {
        ...state,
        isDataUpdated: payload.isDataUpdated,
        isError: false,
      };
    case types.PUT_EDIT_TRANSCRIPTS_DATA_FAILED:
      return {
        ...state,
        isDataUpdated: false,
        isError: true,
      }

    default:
      return state;
  }
}
